import * as colorPalette from '../palette';

export const pageBackground = colorPalette.navy100;
export const pageBackgroundModalActive = colorPalette.navy200;
export const pageBackgroundTopLeft = colorPalette.navy100;
export const pageBackgroundBottomRight = colorPalette.blue150;
export const pageBackgroundLineTop = colorPalette.white;
export const pageBackgroundLineMid = colorPalette.navy100;
export const pageBackgroundLineBottom = colorPalette.blue150;
export const pageText = '#272630';
export const pageTextLight = colorPalette.navy600;
export const pageTextSubdued = colorPalette.navy300;
export const altpageTextSubdued = colorPalette.navy500;
export const pageTextDark = colorPalette.navy800;
export const pageTextPositive = colorPalette.purple600;
export const altPageTextPositive = colorPalette.purple400;
export const pageTextLink = colorPalette.blue600;
export const altPageTextLink = colorPalette.blue300;

export const modalBackground = colorPalette.white;
export const modalBorder = colorPalette.white;

export const cardBackground = colorPalette.white;
export const cardBorder = colorPalette.purple700;
export const cardShadow = colorPalette.navy700;

export const tableBackground = colorPalette.white;
export const altTableBackground = colorPalette.navy50;
export const alt2TableBackground = colorPalette.navy100;
export const tableRowBackgroundHover = colorPalette.navy50;
export const tableText = pageText;
export const altTableText = colorPalette.navy400;
export const alt2TableText = colorPalette.navy600;
export const tableTextSelected = colorPalette.navy700;
export const tableTextHover = colorPalette.navy900;
export const tableTextEditing = colorPalette.navy50;
export const altTableTextEditing = colorPalette.purple50;
export const tableTextEditingBackground = colorPalette.blue500;
export const tableTextInactive = colorPalette.navy500;
export const tableHeaderText = colorPalette.navy600;
export const tableHeaderBackground = colorPalette.white;
export const tableBorder = colorPalette.navy100;
export const tableBorderSelected = colorPalette.purple500;
export const alttableBorderSelected = colorPalette.blue200;
export const tableBorderHover = colorPalette.purple400;
export const tableBorderSeparator = colorPalette.navy400;
export const tableRowBackgroundHighlight = colorPalette.blue150;
export const tableRowBackgroundHighlightText = colorPalette.navy700;
export const tableRowHeaderBackground = colorPalette.navy50;
export const tableRowHeaderText = colorPalette.navy800;
export const sidebarBackground = colorPalette.navy900;
export const sidebarItemBackground = colorPalette.blue800;
export const sidebarItemBackgroundPositive = colorPalette.green500;
export const sidebarItemBackgroundFailed = colorPalette.red300;
export const sidebarItemBackgroundSelected = colorPalette.purple200;
export const sidebarItemBackgroundHover = colorPalette.navy800;
export const sidebarItemAccent = colorPalette.blue800;
export const sidebarItemAccentSelected = colorPalette.purple200;
export const sidebarItemAccentHover = colorPalette.blue700;
export const sidebarItemText = colorPalette.navy150;
export const sidebarItemTextSelected = colorPalette.purple200;
export const sidebarItemTextHover = colorPalette.navy50;

export const tooltipBackground = colorPalette.navy50;
export const tooltipBorder = colorPalette.navy50;

export const menuBackground = colorPalette.white;
export const menuItemBackground = colorPalette.navy50;
export const menuItemBackgroundHover = colorPalette.navy100;
export const menuItemText = colorPalette.navy900;
export const menuItemTextHover = menuItemText;
export const menuItemTextSelected = menuItemText;
export const menuItemTextHeader = colorPalette.purple600;
export const menuBorder = colorPalette.navy100;
export const menuBorderHover = colorPalette.purple100;
export const menuKeybindingText = colorPalette.navy400;
export const altMenuBackground = colorPalette.blue800;
export const alt2MenuBackground = colorPalette.navy900;
export const altMenuItemBackground = colorPalette.blue800;
export const altMenuItemBackgroundHover = colorPalette.blue700;
export const alt2MenuItemBackgroundHover = colorPalette.navy600;
export const altMenuItemText = colorPalette.navy100;
export const alt2MenuItemText = colorPalette.white;
export const altMenuItemTextHover = colorPalette.navy50;
export const altMenuItemTextSelected = colorPalette.purple300;
export const altMenuItemTextHeader = colorPalette.navy400;
export const alt2MenuItemTextHeader = colorPalette.orange150;
export const altMenuBorder = colorPalette.blue700;
export const altMenuBorderHover = colorPalette.purple300;

export const mobileNavBackground = colorPalette.white;
export const mobileNavItem = colorPalette.gray300;
export const mobileNavItemSelected = colorPalette.purple500;
export const mobileAccountShadow = colorPalette.navy300;
export const mobileAccountText = colorPalette.blue800;
export const mobileModalBackground = colorPalette.navy900;
export const mobileModalText = colorPalette.white;
export const altMobileModalText = colorPalette.blue100;
export const mobileDateBackground = colorPalette.navy100;

// Mobile view themes (for the top bar)
export const mobileAccountViewTheme = colorPalette.navy50;
export const mobileAccountsViewTheme = colorPalette.blue800;
export const mobileBudgetViewTheme = colorPalette.purple500;
export const mobileConfigServerViewTheme = colorPalette.purple500;
export const mobileSettingsViewTheme = colorPalette.navy50;
export const mobileTransactionViewTheme = colorPalette.purple500;

export const markdownNormal = colorPalette.purple150;
export const markdownDark = colorPalette.purple400;
export const markdownLight = colorPalette.purple100;

// Button
export const buttonMenuText = colorPalette.navy100;
export const buttonMenuTextHover = colorPalette.navy50;
export const buttonMenuBackground = 'transparent';
export const buttonMenuBackgroundHover = 'rgba(200, 200, 200, .25)';
export const buttonMenuBorder = colorPalette.navy500;
export const buttonMenuSelectedText = colorPalette.green800;
export const buttonMenuSelectedTextHover = colorPalette.orange800;
export const buttonMenuSelectedBackground = colorPalette.orange200;
export const buttonMenuSelectedBackgroundHover = colorPalette.orange300;
export const buttonMenuSelectedBorder = buttonMenuSelectedBackground;

export const buttonPrimaryText = colorPalette.white;
export const buttonPrimaryTextHover = buttonPrimaryText;
export const buttonPrimaryBackground = colorPalette.purple500;
export const buttonPrimaryBackgroundHover = buttonPrimaryBackground;
export const buttonPrimaryBorder = buttonPrimaryBackground;
export const buttonPrimaryShadow = 'rgba(0, 0, 0, 0.3)';
export const buttonPrimaryDisabledText = colorPalette.white;
export const buttonPrimaryDisabledBackground = colorPalette.navy300;
export const buttonPrimaryDisabledBorder = buttonPrimaryDisabledBackground;

export const buttonNormalText = colorPalette.navy900;
export const buttonNormalTextHover = buttonNormalText;
export const buttonNormalBackground = colorPalette.white;
export const buttonNormalBackgroundHover = buttonNormalBackground;
export const buttonNormalBorder = colorPalette.navy150;
export const buttonNormalShadow = 'rgba(0, 0, 0, 0.2)';

export const altbuttonMenuBackground = colorPalette.navy100;
export const buttonNormalSelectedText = colorPalette.white;
export const buttonNormalSelectedBackground = colorPalette.blue600;
export const altButtonNormalSelectedBackground = colorPalette.navy500;

export const buttonNormalDisabledText = colorPalette.navy300;
export const buttonNormalDisabledBackground = buttonNormalBackground;
export const buttonNormalDisabledBorder = buttonNormalBorder;

export const buttonBareText = buttonNormalText;
export const altButtonBareText = colorPalette.navy200;
export const buttonBareTextHover = buttonNormalText;
export const buttonBareBackground = 'transparent';
export const buttonBareBackgroundHover = 'rgba(100, 100, 100, .15)';
export const buttonBareBackgroundActive = 'rgba(100, 100, 100, .25)';
export const buttonBareDisabledText = buttonNormalDisabledText;
export const buttonBareDisabledBackground = buttonBareBackground;

export const noticeBackground = colorPalette.green150;
export const altNoticeBackground = colorPalette.green100;
export const alt2NoticeBackground = colorPalette.green50;
export const noticeText = colorPalette.green500;
export const altNoticeText = colorPalette.green900;
export const alt2NoticeText = colorPalette.green800;
export const alt3NoticeText = colorPalette.green600;
export const alt4NoticeText = colorPalette.green700;
export const noticeAccent = colorPalette.green200;
export const altNoticeAccent = colorPalette.green500;
export const warningBackground = colorPalette.orange200;
export const altWarningBackground = colorPalette.orange150;
export const alt2WarningBackground = colorPalette.orange100;
export const warningText = colorPalette.orange800;
export const altWarningText = colorPalette.orange900;
export const alt2WarningText = colorPalette.orange700;
export const alt3WarningText = colorPalette.orange500;
export const alt4WarningText = colorPalette.orange800;
export const alt5WarningText = colorPalette.orange600;
export const warningAccent = colorPalette.orange400;
export const altWarningAccent = colorPalette.orange600;
export const errorBackground = colorPalette.red50;
export const altErrorBackground = colorPalette.red100;
export const errorText = colorPalette.red500;
export const altErrorText = colorPalette.red900;
export const alt2ErrorText = colorPalette.red600;
export const alt3ErrorText = colorPalette.red700;
export const alt4ErrorText = colorPalette.red300;
export const alt5ErrorText = colorPalette.red400;
export const errorAccent = colorPalette.red200;
export const altErrorAccent = colorPalette.red500;
export const upcomingBackground = colorPalette.purple100;
export const upcomingText = colorPalette.purple900;
export const altUpcomingText = colorPalette.purple500;
export const upcomingAccent = colorPalette.purple100;

export const formLabelText = colorPalette.blue500;
export const altFormLabelText = colorPalette.blue700;
export const formLabelBackground = colorPalette.blue200;
export const formInputBackground = colorPalette.navy50;
export const formInputBackgroundSelected = colorPalette.white;
export const formInputBackgroundSelection = colorPalette.purple500;
export const formInputBorder = colorPalette.navy150;
export const formInputTextReadOnlySelection = colorPalette.navy50;
export const formInputBorderSelected = colorPalette.purple500;
export const altFormInputBorderSelected = colorPalette.blue500;
export const formInputText = colorPalette.navy900;
export const formInputTextSelected = colorPalette.navy50;
export const formInputTextPlaceholder = colorPalette.navy300;
export const formInputTextPlaceholderSelected = colorPalette.navy200;
export const formInputTextSelection = colorPalette.navy100;
export const formInputShadowSelected = colorPalette.purple300;
export const altFormInputShadowSelected = colorPalette.blue300;
export const formInputTextHighlight = colorPalette.purple200;

export const pillBackground = colorPalette.navy150;
export const pillText = colorPalette.navy800;
export const pillTextHighlighted = colorPalette.purple600;
export const pillBorder = colorPalette.navy150;
export const altPillBorder = colorPalette.navy200;
export const pillBackgroundSelected = colorPalette.blue150;
export const pillTextSelected = colorPalette.blue900;
export const pillBorderSelected = colorPalette.purple500;
export const altPillBackground = colorPalette.navy100;
export const altPillText = colorPalette.navy900;
export const alt2PillText = colorPalette.navy500;

export const reportsRed = colorPalette.red300;
export const reportsBlue = colorPalette.blue400;
export const reportsLabel = colorPalette.navy900;
